//已领取标记，位于运算：&2=2:599鸡王 01,4:大吉大利鸡王宝藏 100,8:加码礼包1 1000,16:加码礼包2, 10000,32:鸡王系列换装包,64:枪王之王特惠包
export default {
    '2' : 2,
    '4' : 4,
    '8' : 8,
    '16' : 16,
    '32' : 32,
    '64' : 64,
}


// WEBPACK FOOTER //
// ./src/assets/js/gid_config.js